module.exports = __webpack_public_path__ + "img/ios.d8964748.svg";